import React, { Fragment, PureComponent } from "react";
import { shopContext } from "../../contexts/aniplus";
import { withRouter } from "react-router-dom";
// import axios from "axios";

// import { ToastContainer, toast } from "react-toastify"; //토스트(toast)
// import { confirmAlert } from "react-confirm-alert"; //알럿창(alert confirm)

import MyNotiList from "./MyNotiList";
import { isMobile, isAndroid, isIOS } from "react-device-detect";

class MyNoti extends PureComponent {
  state = {
    index: this.props.childProps.index ? this.props.childProps.index : 0,
  };
  componentDidMount = () => {};
  _changeIndex = (index) => {
    const { _myMenu } = this.props.childProps;
    _myMenu(index);
  };

  render() {
    // const { index } = this.props.childProps;
    return (
      <Fragment>
        <div className="my_con">
          <div className="my_tab">
            {isMobile ? null : (
              <h3>
                <a href="#" class="btn_back"></a>내 본방 예약 알림
              </h3>
            )}
          </div>

          <MyNotiList />
        </div>
      </Fragment>
    );
  }
}

export default shopContext(withRouter(React.memo(MyNoti)));
